import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="Chat on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-ink shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-[transform,box-shadow] duration-300 hover:scale-110 hover:shadow-[0_8px_40px_rgba(37,211,102,0.6)]"
  >
    <MessageCircle className="h-6 w-6" fill="currentColor" />
  </motion.a>
);
